export default __webpack_public_path__ + "img/4bb46aa49cd4fba555a6c86da3524d8d.svg";